import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconComponent } from 'angular-tabler-icons';
import { ControlsModule } from 'src/app/controls/controls.module';

@Component({
  selector: 'app-new-test-widget',
  templateUrl: './new-test-widget.component.html',
  styleUrls: ['./new-test-widget.component.scss'],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule,
    TablerIconComponent
  ]
})
export class NewTestWidgetComponent {

}
